import React from "react";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ChatIcon from "@mui/icons-material/Chat";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import FeedIcon from "@mui/icons-material/Feed";
import WorkIcon from "@mui/icons-material/Work";

export const mobileUnauthMenus = [
  {
    titleId: "nav.faq",
    target: "faq",
    icon: (props) => <HelpOutlineIcon {...props} />,
  },
  {
    titleId: "menu.blog_posts",
    target: "candidates/posts",
    icon: (props) => <FeedIcon {...props} />,
  },
  {
    titleId: "nav.contact",
    target: "contact-us",
    icon: (props) => <ChatIcon {...props} />,
  },
  {
    titleId: "application.more_jobs",
    target: "job-offers",
    icon: (props) => <WorkIcon {...props} />,
  },
  {
    titleId: "nav.candidate.go_recruiter",
    logout: true,
    target: "recruiter",
    icon: (props) => <SwapHorizIcon {...props} />,
  },
];

export const mobileAuthenticatedSubmenus = [
  {
    code: "help",
    titleId: "nav.help",
    links: [
      {
        titleId: "nav.faq",
        target: "candidate/faq",
        icon: (props) => <HelpOutlineIcon {...props} />,
      },
      {
        titleId: "nav.contact",
        target: "candidate/contact-us",
        icon: (props) => <ChatIcon {...props} />,
      },
      {
        titleId: "nav.candidate.go_recruiter",
        logout: true,
        target: "recruiter",
        icon: (props) => <SwapHorizIcon {...props} />,
      },
    ],
    isOpen: false,
  },
];

export const desktopAuthenticatedSubmenus = [
  {
    titleId: "nav.help",
    links: [
      {
        titleId: "nav.faq",
        target: "candidate/faq",
        icon: (props) => <HelpOutlineIcon {...props} />,
      },
      {
        titleId: "nav.contact",
        target: "candidate/contact-us",
        icon: (props) => <ChatIcon {...props} />,
      },
      {
        titleId: "nav.candidate.go_recruiter",
        target: "recruiter",
        logout: true,
        icon: (props) => <SwapHorizIcon {...props} />,
      },
    ],
  },
];
